export default value => RegExp(/^[a-z]*$/i).test(value);
